export class InstantMessengerDto {
  id: string;
  imHandle: string;
  type: string;

  constructor(d?: InstantMessengerDto) {
    if (!d) {
      return;
    }
    this.id = d.id;
    this.imHandle = d.imHandle;
    this.type = d.type;
  }
}
